import { render, staticRenderFns } from "./GroupName.vue?vue&type=template&id=5bd7e9bd&scoped=true&"
import script from "./GroupName.vue?vue&type=script&lang=js&"
export * from "./GroupName.vue?vue&type=script&lang=js&"
import style0 from "./GroupName.vue?vue&type=style&index=0&id=5bd7e9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7e9bd",
  null
  
)

export default component.exports